import { cn, Loader2Icon } from 'oddle-shop-monorepo.design-system'

const Loading = ({ className }: { className?: string }) => {
  return (
    <Loader2Icon
      className={cn('text-button-text h-4 w-4 animate-spin', className)}
    />
  )
}

export default Loading
